module.exports = __webpack_public_path__ + "static/img/logo.15664e0d.png";